module.exports = __webpack_public_path__ + "static/media/mini.1f7d939a.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E5/mini.png
// module id = 729
// module chunks = 0